/** Must match the `getGet('mdeFeedback')` read in Posterbuilder.php. */
export const MDE_FEEDBACK_URL_PARAM = 'mdeFeedback';

/** The subset of backend `MdeErrorCode` that `makedesigneditable/start` can refuse with. */
export enum MdeStartErrorCode {
  FEATURE_DISABLED = 'featureDisabled',
  IMAGE_NOT_FOUND = 'imageNotFound',
  IMAGE_NOT_ALLOWED = 'imageNotAllowed',
  INSUFFICIENT_CREDITS = 'insufficientCredits',
  ALREADY_RUNNING = 'alreadyRunning',
  START_FAILED = 'startFailed',
  ENQUEUE_FAILED = 'enqueueFailed',
}

export enum MdeStartKind {
  STARTED = 'started',
  RESUMED = 'resumed',
  REUSED = 'reused',
}

export interface MdeStartPayload {
  kind: MdeStartKind;
  jobId: string | null;
  posterHashedId: string | null;
}

/** `posterHashedId` is the blank poster pre-created for the job; null when the image has no known dimensions. */
export interface MdeJobRun {
  kind: MdeStartKind.STARTED | MdeStartKind.RESUMED;
  jobId: string;
  posterHashedId: string | null;
}

export interface MdeReusedDesign {
  kind: MdeStartKind.REUSED;
  posterHashedId: string;
}

export type MdeStartResponse = MdeJobRun | MdeReusedDesign;

export interface MdeStatusRequest {
  jobId: string;
}

/** The fields of the backend `MdeJobResult::toArray()` the client reads. */
export interface MdeJobResult {
  posterHashedId: string;
  jobHashedId: string;
}

export interface MdeOutcome {
  jobId: string;
  posterHashedId: string;
}
